import _default from './Sidebar';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/modules/Sidebar/index.js
// module id = 901
// module chunks = 0